import { Component, h } from '@stencil/core';

@Component({
  tag: 'card-benefits-skeleton',
  shadow: true,
  styleUrl: 'card-benefits.scss'
})
export class CardBenefitsSkeleton {
  render() {
    return (
      <div>
        <div class="flex justify-between py-4 p-4 items-center">
          <skeleton-element class="h-5 w-1/3" />
          <skeleton-element class="h-4 w-4 rounded-full" />
        </div>

        <div class="flex gap-4 px-4 overflow-x-auto">
          {[...Array(4)].map((_, idx) => (
            <div key={idx} class="flex flex-col items-center space-y-2 min-w-[60px]">
              <skeleton-element class="h-12 w-12 rounded-full" />
              <skeleton-element class="h-3 w-12" />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
